import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import { DatePicker,Select,Icon } from 'element-ui';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import echarts from 'echarts'
import { VueAxios } from './utils/request'
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

// Vue.use(DatePicker)
// Vue.use(Select)
// Vue.use(Icon)
Vue.use(ElementUI)
Vue.use(VueAxios)

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
